/*
 * @Author: kirito
 * @Date: 2025-08-Mo 11:11:22
 * @Last Modified by:   kirito
 * @Last Modified time: 2025-08-Mo 11:11:22
 * @Description: 折叠面板组件
 */

(function (global) {
  global.GeekComponents = global.GeekComponents || {};

  function Collapse({ title, children, className = "", headerClassName = "" }) {
    const [open, setOpen] = React.useState(true);
    const contentRef = React.useRef(null);

    return React.createElement(
      "div",
      { className: `${className}` },
      React.createElement(
        "div",
        { className: `${headerClassName}`, onClick: () => setOpen(!open) },
        title,
        React.createElement("span", {
          className: "collapse-arrow" + (open ? " open" : ""),
          dangerouslySetInnerHTML: {
            __html: `<span>
                    <svg class="icon icon--caret" aria-hidden="true" focusable="false" role="presentation" width="6" height="7" viewBox="0 0 6 7">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M.293.793a1 1 0 0 0 0 1.414L3.5 5.414l3.207-3.207A1 1 0 0 0 5.293.793L3.5 2.585 1.707.793a1 1 0 0 0-1.414 0Z"></path>
                    </svg>
                </span>`,
          },
        })
      ),
      React.createElement(
        "div",
        {
          ref: contentRef,
          className: "collapse-content" + (open ? " open" : ""),
        },
        children
      )
    );
  }

  // 挂到全局
  global.GeekComponents.Collapse = Collapse;
})(window);
